import { useEffect } from 'react';

/** Sets `document.title` to "<title> - <app name>". */
export default function useDocumentTitle(title) {
  useEffect(() => {
    const appName = process.env.REACT_APP_NAME || 'Extracta LABS';
    document.title = title ? `${title} - ${appName}` : appName;
  }, [title]);
}
